// // socket.js
// import { io } from 'socket.io-client';

// // Get the backend URL from environment variables
// const getSocketUrl = () => {
//   // For React apps, environment variables must start with REACT_APP_
//   const socketUrl = process.env.REACT_APP_SOCKET_URL || 
//                    process.env.REACT_APP_API_BASE_URL || 
//                    'http://localhost:3000';
  
//   return socketUrl;
// };

// const SOCKET_SERVER_URL = getSocketUrl();

// export const socket = io(SOCKET_SERVER_URL, {
//   transports: ['websocket', 'polling'],
//   withCredentials: true,
// });

// console.log('🔌 Connecting to socket server:', SOCKET_SERVER_URL);





// Alternative
import { io } from 'socket.io-client';

// Get the backend URL from environment variables
const getSocketUrl = () => {
  // For React apps, environment variables must start with REACT_APP_
  const socketUrl = process.env.REACT_APP_SOCKET_URL ||
                    process.env.REACT_APP_API_BASE;

  // Check if socket URL is defined in environment variables
  if (!socketUrl) {
    console.error('ERROR: No socket URL defined in environment variables!');
    console.error('Please add REACT_APP_SOCKET_URL or REACT_APP_API_BASE to your .env file');
    throw new Error('Socket URL not configured');
  }

  return socketUrl;
};

let SOCKET_SERVER_URL;
let socket;

try {
  SOCKET_SERVER_URL = getSocketUrl();
  socket = io(SOCKET_SERVER_URL, {
    transports: ['websocket', 'polling'],
    withCredentials: true, // Sends httpOnly cookies with socket connection
  });
  console.log('Connecting to socket server:', SOCKET_SERVER_URL);

  // Join user room on connect — userId will be set by calling joinUserRoom() from AuthContext
  // Socket.IO sends cookies automatically with withCredentials: true
} catch (error) {
  console.error('Failed to initialize socket:', error.message);
  // Export a dummy socket object to prevent import errors
  socket = {
    on: () => {},
    emit: () => {},
    disconnect: () => {},
  };
}

/**
 * Call this after login/auth to join the user's socket room.
 * Since we no longer have access to the JWT in localStorage,
 * the userId must be passed explicitly from the auth context.
 */
export function joinUserRoom(userId) {
  if (userId && socket?.emit) {
    socket.emit('join_user', { userId });
  }
}

export { socket };


// alternative 2
// import { io } from 'socket.io-client';

// // Get the backend URL from environment variables
// const getSocketUrl = () => {
//   // For React apps, environment variables must start with REACT_APP_
//   const socketUrl = process.env.REACT_APP_SOCKET_URL || 
//                     process.env.REACT_APP_API_BASE_URL;
  
//   // Check if socket URL is defined in environment variables
//   if (!socketUrl) {
//     console.error('❌ ERROR: No socket URL defined in environment variables!');
//     console.error('Please ensure REACT_APP_SOCKET_URL or REACT_APP_API_BASE_URL is set in your ServerAvatar environment variables');
//     throw new Error('Socket URL not configured - check ServerAvatar environment variables');
//   }
  
//   return socketUrl;
// };

// let SOCKET_SERVER_URL;
// let socket;

// try {
//   SOCKET_SERVER_URL = getSocketUrl();
//   socket = io(SOCKET_SERVER_URL, {
//     transports: ['websocket', 'polling'],
//     withCredentials: true,
//   });
//   console.log('🔌 Connecting to socket server:', SOCKET_SERVER_URL);
// } catch (error) {
//   console.error('Failed to initialize socket:', error.message);
//   // Export a dummy socket object to prevent import errors
//   socket = {
//     on: () => {},
//     emit: () => {},
//     disconnect: () => {},
//   };
// }

// export { socket };